const formatUSD = (amount) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
};

const unformatUSD = (amount) => {
  if (!amount) return "";
  return amount.toString().replace("$", "").replace(",", "");
};

const getDecimal = (num) => {
  if (!num) return "";
  num = Math.round(num * 100) / 100;
  const split = num.toString().split(".");
  if (split.length > 1) return split[1].length > 1 ? split[1] : `${split[1]}0`;
  return "";
};

export { formatUSD, unformatUSD, getDecimal };
